import { Quote } from "lucide-react";

export interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  company: string;
  initials: string;
}

export function TestimonialCard({ quote, name, title, company, initials }: TestimonialCardProps) {
  return (
    <div className="flex h-full flex-col rounded-2xl border border-border bg-card p-6 shadow-card">
      <Quote className="mb-4 text-primary" size={24} />
      <p className="mb-6 flex-1 text-sm leading-relaxed text-foreground">{quote}</p>
      <div className="flex items-center gap-3 border-t border-border pt-4">
        <div className="grid h-11 w-11 place-items-center rounded-full bg-gradient-hero text-sm font-semibold text-primary-foreground">
          {initials}
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground">{name}</p>
          <p className="text-xs text-muted-foreground">
            {title}, {company}
          </p>
        </div>
      </div>
    </div>
  );
}
